import CityProfileDetails from '@app/components/CityProfileDetails'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { CityViewPageProps } from './CityViewPage'

export default class CityDetails extends React.PureComponent<
  CityViewPageProps
> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.city.place.cityState} :: Details`}>
        <CityProfileDetails cityProfile={this.props.city} />
      </DocumentTitle>
    )
  }
}
